import React from "react";
import LoginButton from "./LoginButton";
import { Link } from "gatsby-link";
export interface ButtonProps {
  text?: string;
  href?: string;
  external?: boolean;
  className?: string;
  variant?:
    | "primary"
    | "newPrimary"
    | "newSecondary"
    | "newPrimaryLight"
    | "secondary"
    | "outline"
    | "navPrimary"
    | "apply"
    | "login";
}

const Button = (props: ButtonProps) => {
  const { text, variant, className, external, href } = props;

  switch (variant) {
    case "login":
      return <LoginButton />;
    case "outline":
      return (
        <button
          sx={{
            cursor: "pointer",
            variant: "buttons.outline",
            my: "20px",
            width: 200,
            "&:hover": {
              background: "linear-gradient(to bottom, #D91828 0, #A1111D 100%)",
              color: "white",
            },
          }}
        >
          {text}
        </button>
      );
    default:
      return (
        <>
          {external ? (
            <a
              className={className}
              rel="noreferrer noopener"
              href={href}
              sx={{
                cursor: "pointer",
                variant: `buttons.${variant}`,
                width: 200,
              }}
            >
              {text}
            </a>
          ) : (
            <Link
              className={className}
              sx={{
                cursor: "pointer",
                variant: `buttons.${variant}`,
                width: 200,
              }}
              to={href}
            >
              {text}
            </Link>
          )}
        </>
      );
  }
};

export default Button;
